import React from 'react';
import { Route, Routes,	Navigate, Link } from 'react-router-dom';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';

import { ConnectedUserContext } from '../../connectedUser-context';

import Axios from 'axios';
import moment from 'moment';

// Components
import AdminSeasonsHome from './AdminSeasonsHome';
import ScoresheetsNav from '../scoresheet/ScoresheetsNav';
import LeagueAdmin from './LeagueAdmin';
import SeasonAdmin_nav from './SeasonAdmin_nav';
import RateSysAdmin from '../customers/RateSysAdmin';
import SeasonSchedule from './SeasonSchedule';

// App
import LeaguesDropdown from '../../shared/LeaguesDropdown';
import SeasonsDropdown from '../../shared/SeasonsDropdown';


// Refs:  React router and tabs
// https://github.com/reactstrap/reactstrap/issues/83#issue-168537815
// https://github.com/reactstrap/reactstrap/issues/298
// https://codesandbox.io/s/github/browniefed/tmp/tree/reactRouterDynamicRoutes/?from-embed
// https://stackoverflow.com/questions/51203888/reactjs-routing-to-different-tabs

// liveScoresheets.status
// PRÉPARATION: affichage dans Admin seulement
// ACTIVÉES: affichage du bouton dans Standings pour les joueurs

function isScheduledProgramsEnabled(season) {
  return (
    season?.liveScoresheets?.status === 'PRÉPARATION' ||
    season?.liveScoresheets?.status === 'ACTIVÉES'
  );
}

class AdminSeasons extends React.Component {

	static contextType = ConnectedUserContext;

  constructor(props) {
		super(props);

		this.state = {
			activeTab: 'home',		// home, scoresheets, league, season, ratingSys, schedule
			leagues: [],
			leagueId: "",
			league: {},
			seasons: [],
			seasonId: "0",
			season: {},
			bRateSysExists: false
		};
	
		this.toggle = this.toggle.bind(this);
		this.loadLeagues = this.loadLeagues.bind(this);
		this.loadSeasons = this.loadSeasons.bind(this);
		this.loadSeason = this.loadSeason.bind(this);
		this.reloadSeason = this.reloadSeason.bind(this);
		this.leagueChange = this.leagueChange.bind(this);
		this.seasonChange = this.seasonChange.bind(this);
}

	componentDidMount() {
    // console.log('%cADMIN_SEASONS: componentDidMount:', 'color: blue;');
		this.loadLeagues();
	}

	componentDidUpdate(prevProps, prevState) {
	  const { season, bRateSysExists, activeTab } = this.state;

	  let bGetBackHome = false;

	  // console.log('AdminSeasons: componentDidUpdate')
	  // console.log('season', season)
	  // console.log('activeTab', activeTab)
	  // console.log('bRateSysExists', bRateSysExists)

	  // season changed - verify access and activeTab
	  if (prevState.season?._id !== season?._id) {
	  	if (!bRateSysExists && (activeTab === 'ratingSys')) {
				bGetBackHome = true;
			}

			if (bGetBackHome) {
	    	this.setState({ activeTab: 'home' });
	    }
	  }
	}

	toggle(tab) {
		if (this.state.activeTab !== tab) {
			this.setState({ activeTab: tab });
		}
	}

	render() {
    // console.log('%cADMIN_SEASONS: render', 'color: blue;');
    let { bRateSysExists, activeTab } = this.state;
    let { leagueId, leagues, league, seasonId, seasons, season } = this.state;

    const { connectedUser } = this.context;
		if (!connectedUser) {	return;	}

		return (
      <div style={{ minHeight: '600px' }}>
				{/* ----------------- LIGUE & SAISON selectors ---------------- */}
				<div className="row row-align-items-flex-end">
					<div className="col-md-6 col-12">
					<div className="card card-accent-success">
					<div className="card-header">
						<i className="fa fa-th-large"></i>Ligue et Saison
					</div>

					<div className="card-block">
						Sélectionner une Ligue
						<LeaguesDropdown value={leagueId} leagues={leagues} 
							leagueChange={this.leagueChange} bOption0={false}></LeaguesDropdown>
							<br/>

						Sélectionner une Saison
						<SeasonsDropdown value={seasonId} seasons={seasons} 
							seasonChange={this.seasonChange}></SeasonsDropdown>
					</div>
					</div>
					</div>

					<div className="col-md-6 col-12 row-margin-bottom-20">
						<p>* Pour une utilisation optimale de Statelo en mode Administrateur, utiliser le navigateur Google Chrome que vous pouvez télécharger ici</p>
	        	<a href={'https://www.google.fr/intl/fr/chrome/'} target="_blank">
			        <input type="button" className="btn btn-primary btn-sm db-menu-padsides" value="Télécharger Google Chrome" />
	        	</a>
					</div>
				</div>

				{/* ----------------- TAB CONTAINER ---------------- */}
				<div className="row">
					<div className="col-md-12">
					<div className="card card-accent-success">
					<div className="card-block">
					<Nav tabs>

						{ connectedUser.isSeasonAdmin && 
						<NavItem>
							<NavLink 
								active={activeTab === 'home'}
								onClick={() => { this.toggle('home'); }}>
								Accueil
							</NavLink>
						</NavItem>}

						{ connectedUser.isScoresheetAdmin && 
						<NavItem>
							<NavLink 
								active={activeTab === 'scoresheets'}
								onClick={() => { this.toggle('scoresheets'); }}>
								Pointages
							</NavLink>                        
						</NavItem>}

						{ connectedUser.isLeagueAdmin && 
						<NavItem>
							<NavLink 
								active={activeTab === 'league'}
								onClick={() => { this.toggle('league'); }}>
								Ligue
							</NavLink>                        
						</NavItem>}

						{ connectedUser.isSeasonAdmin && 
						<NavItem>
							<NavLink 
								active={activeTab === 'season'}
								onClick={() => { this.toggle('season'); }}>
								Saison
							</NavLink>                        
						</NavItem>}

{/*
						FAIRE CECI AUTREMENT
						Scoresheets-access: Same as seasons but limited to team config only
						{ connectedUser.isScoresheetAdmin && 
						<NavItem>
							<NavLink tag={Link} to="/admsafe/seasons/season/eqcfg"
								active={activeTab === '5'}
								onClick={() => { this.toggle('5'); }}>
								Équipes
							</NavLink>                        
						</NavItem>}
*/}
						{ connectedUser.isSeasonAdmin && bRateSysExists && 
						<NavItem>
							<NavLink 
								active={activeTab === 'ratingSys'}
								onClick={() => { this.toggle('ratingSys'); }}>
								Cotation
							</NavLink>                        
						</NavItem>}

						{ connectedUser.isSeasonAdmin && isScheduledProgramsEnabled(season) && 
						<NavItem>
							<NavLink 
								active={activeTab === 'schedule'}
								onClick={() => { this.toggle('schedule'); }}>
								Programmes
							</NavLink>                        
						</NavItem>}

					</Nav>

					{/* ----------------- TAB CONTENT - ROUTER ---------------- */}
					<TabContent activeTab={this.state.activeTab}>
					<TabPane tabId={this.state.activeTab}>
						{this.renderTabContent()}
					</TabPane>
					</TabContent>

				</div>
				</div> 
				</div>
				</div>
				<br/>
			</div>
		)
	}

  renderTabContent() {
    const { activeTab, season, seasons, league, bRateSysExists } = this.state;

		// home, scoresheets, league, season, ratingSys, schedule
    switch (activeTab) {
      case 'home':
        return <AdminSeasonsHome season={season} />;

      case 'scoresheets':
        return <ScoresheetsNav season={season} />;

      case 'league':
        return <LeagueAdmin league={league} seasons={seasons} reloadLeagues={this.loadLeagues}/>;

      case 'season':
        return <SeasonAdmin_nav season={season} reloadSeason={this.reloadSeason} />;

      case 'ratingSys':
        return <RateSysAdmin season={season} bRateSysExists={bRateSysExists} />;

      case 'schedule':
        return <SeasonSchedule season={season} bEnableSheduledPrograms={isScheduledProgramsEnabled(season)} />

      default:
        return <div>Section inconnue</div>;
    }
  }

	// ***********************************************************************************
	// LEAGUES
	// ***********************************************************************************
	loadLeagues() {
    console.log('%cADMIN_SEASONS: loadLeagues', 'color: blue;');

		let { leagueId } = this.state;
		const { connectedUser } = this.context;
		
		console.log("ADMIN_SEASONS: connectedUser", connectedUser);

		if (!connectedUser) { return; }

		Axios.get('/api/leagues/byUserId/' + connectedUser.user._id)
			.then(response => {
				var leagues = response.data;
				var league = "";

				// Pick first by default, if no leagueId is set
				if(leagues.length !== 0) {
					if (leagueId !== "") {
						leagues.forEach(leagueItem => {
							if(leagueItem._id === leagueId) {
								league = leagueItem;
							}
						});
					}
					else {
						leagueId = leagues[0]._id;
						league = leagues[0];
					}

					this.loadSeasons(leagues, leagueId, league);
				}
		});
	}

	leagueChange(leagueId) {
		// console.log('Admin: leagueChange');
		// console.log(leagueId);

		var league = {};
		var leagues = this.state.leagues;
		leagues.forEach(leagueItem => {
			if(leagueItem._id === leagueId) {
				league = leagueItem;
			}
		});

		this.loadSeasons(leagues, leagueId, league);
	}

	seasonChange(seasonId) {
		// console.log('Admin: seasonChange');
		// console.log(seasonId);
		this.loadSeason(this.state.leagueId, seasonId);
	}

	// ***********************************************************************************
	// Seasons, Scoresheets, ScoresheetFormat, Data
	// ***********************************************************************************
	loadSeasons(leagues, leagueId, league) {
    console.log('%cADMIN_SEASONS: loadSeasons', 'color: blue;');

		const { connectedUser } = this.context;
		var seasonId = "0";

		// Get Seasons Table for this leagueId
		Axios.get('/api/seasons/leagueId/' + leagueId + '/userId/' + connectedUser.user._id).then((response) => {
			var seasons = response.data;

			// Default season id the first on list
			if(seasons.length !== 0) {
				seasonId = seasons[seasons.length - 1]._id;  // pick first
			}

			if (seasonId !== "0") {
				Axios.get('/api/seasons/' + seasonId).then((response) => {
				Axios.get('/api/ratesys/rateSysExisting/' + seasonId).then((responseRatesys) => {

					var season = response.data.season;
					if(season.standingTypeTeams === null) {
						season.standingTypeTeams = 0;
					}
					if(season.standingTypePlayers === null) {
						season.standingTypePlayers = 0;
					}
					season.dateStart = moment(season.dateStart).utc().format('YYYY-MM-DD');
					season.dateEnd = moment(season.dateEnd).utc().format('YYYY-MM-DD');

					// console.log('Admin: setState: loadSeason');
					this.setState({
						leagues: leagues,
						leagueId: leagueId,
						league: league,
						seasons: seasons,
						seasonId: seasonId,
						season: season,
						bRateSysExists: responseRatesys.data.exists
					});

				  const clsIds = {charterId: "0", leagueId: leagueId, seasonId: seasonId};
					this.props.refreshConnectedUser(clsIds, "adminseasons")
				});
				});

			} else {
				// ### DEBUG ###
				// console.warn("DEBUG HERE: REMOVE!");
				// seasonId = "6308ca58b8dc73325e70ccd0";
				this.setState({
					leagues: leagues,
					leagueId: leagueId,
					league: league,
					seasons: seasons,
					seasonId: seasonId,
					season: {},                 // test
				});                

			  const clsIds = {charterId: "0", leagueId: leagueId, seasonId: seasonId};
				this.props.refreshConnectedUser(clsIds, "adminseasons")
			}
		});
	}

	reloadSeason() {
    // console.log('%cADMIN_SEASONS: reloadSeason', 'color: blue;');
		this.loadSeason(this.state.leagueId, this.state.seasonId);
	}

	loadSeason(leagueId, seasonId) {
    // console.log('%cADMIN_SEASONS: loadSeason', 'color: blue;');
		// console.log(seasonId);

		if (seasonId !== "0") {
			Axios.get('/api/seasons/' + seasonId).then((response) => {
			Axios.get('/api/ratesys/rateSysExisting/' + seasonId).then((responseRatesys) => {

				var season = response.data.season;
				if(season.standingTypeTeams === null) {
					season.standingTypeTeams = 0;
				}
				if(season.standingTypePlayers === null) {
					season.standingTypePlayers = 0;
				}
				season.dateStart = moment(season.dateStart).utc().format('YYYY-MM-DD');
				season.dateEnd = moment(season.dateEnd).utc().format('YYYY-MM-DD');

				// console.log('Admin: setState: loadSeason');
				this.setState({
					seasonId: seasonId,
					season: season,
					bRateSysExists: responseRatesys.data.exists
				});

			  const clsIds = {charterId: "0", leagueId: leagueId, seasonId: seasonId};
				this.props.refreshConnectedUser(clsIds, "adminseasons")
			});
			});
		}
	}

};

export default AdminSeasons;